import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({ size, ...rest }: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="8" fill="#FEFEFE" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.43506 20.7257C10.049 21.5354 10.9841 22 12 22C13.0159 22 13.951 21.5354 14.5649 20.7257C14.9834 20.1737 15.6698 19.8887 16.3565 19.9838C17.3627 20.1215 18.3523 19.7893 19.0711 19.0708C19.7896 18.3523 20.1224 17.3631 19.9838 16.3563C19.8893 15.6699 20.1737 14.9836 20.726 14.5647C21.5357 13.9511 22 13.0161 22 12.0002C22 10.9839 21.5357 10.0492 20.726 9.43494C20.1737 9.01644 19.8893 8.33009 19.9838 7.64341C20.1224 6.63694 19.7896 5.64734 19.0711 4.92885C18.3523 4.21035 17.3617 3.87789 16.3565 4.0162C15.6695 4.111 14.9834 3.82627 14.5649 3.27401C13.951 2.4646 13.0159 2 12 2C10.9841 2 10.049 2.4646 9.43506 3.27401C9.01656 3.82627 8.33084 4.11165 7.64351 4.0162C6.63669 3.87757 5.6474 4.21068 4.9289 4.92885C4.21039 5.64734 3.8776 6.63694 4.01623 7.64341C4.11071 8.33009 3.8263 9.01644 3.27403 9.43494C2.46429 10.0492 2 10.9839 2 12.0002C2 13.0161 2.46429 13.9511 3.27403 14.5647C3.8263 14.9836 4.11071 15.6699 4.01623 16.3563C3.8776 17.3631 4.21039 18.3523 4.9289 19.0708C5.6474 19.7896 6.63604 20.1215 7.64351 19.9838C8.33117 19.8883 9.01656 20.1737 9.43506 20.7257ZM18.631 13.8397C18.631 14.3407 18.2046 14.7139 17.7781 14.7139C17.3091 14.7139 16.9252 14.3088 16.9252 13.8397C16.9252 13.3707 17.3304 12.9868 17.7781 12.9868C18.2258 12.9868 18.631 13.3707 18.631 13.8397ZM6 14.5221H7.30066V11.5053C7.30066 10.7165 7.67393 10.2153 8.52656 10.2153C9.37918 10.2153 9.75245 10.7162 9.75245 11.5053V14.5221H11.0531V11.5266C11.0531 9.95932 10.1151 9 8.52656 9C6.93804 9 6 9.95932 6 11.5266V14.5221ZM16.7351 12.326C16.7351 13.7224 15.8716 14.7139 14.2086 14.7139C12.5562 14.7139 11.682 13.7224 11.682 12.326V9.1918H12.9827V12.1767C12.9827 12.9871 13.3985 13.4774 14.1979 13.4774C14.9974 13.4774 15.4345 12.9868 15.4345 12.1767V9.1918H16.7351V12.326Z"
          fill="#006EFF"
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 불가능,
 *
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'nuUser');
export default IconComponent;
